<template>
  <div>
    <job-menu :job="job"></job-menu>

    <div class="my-10 px-4">
      <div class="flex justify-center items-center">
        <h1 class="text-3xl font-bold text-center w-full mb-5 md:mb-0 md:w-auto">
          {{ __('Create new notification for #:id', {id: job.id}) }}
        </h1>
      </div>

      <div class="bg-white px-4 py-10 shadow-md mt-10 overflow-x-auto">
        <div class="max-w-5xl mx-auto">
          <h2 class="text-3xl text-gray-800">
            {{ __("Finalize job") }}
          </h2>

          <div class="mt-10">
            <h3 class="text-xl font-bold">{{ __("Media") }}</h3>

            <div class="flex flex-wrap -mx-2 mt-2" v-if="form.media">
              <label class="w-1/3 p-2 flex cursor-pointer" v-for="media in form.media" :key="media.id" :class="{'opacity-50 cursor-not-allowed': media.collection_name === 'videos' && !media.processed_at}">
                <input :id="'operation-' + media.id" v-model="media.checked" :checked="media.checked" type="checkbox" class="checkbox mr-2 transform scale-125" :disabled="media.collection_name === 'videos' && !media.processed_at"/>
                <div class="relative w-full">
                  <div class="absolute w-full h-full bg-black opacity-0 hover:opacity-25"></div>
                  <div class="bg-gray-500 text-white text-sm px-2 py-1 absolute bottom-0 left-0 z-10">{{ media.created_at }} <span v-if="media.collection_name === 'videos' && !media.processed_at">- processing...</span></div>
                  <img v-if="media.collection_name === 'images'" :src="media.url" alt="" class="inset-0 h-full w-full object-contain bg-black"/>
                  <video v-if="media.collection_name === 'videos'" class="inset-0 h-full w-full object-contain bg-black" controls>
                    <source :src="media.url" type="video/webm">
                    <source :src="media.url_mp4" type="video/mp4">
                  </video>
                </div>
              </label>
            </div>
          </div>

          <div class="mt-10 flex justify-end">
            <button :disabled="!job.permissions.update" class="h-16 flex items-center justify-center text-2xl px-8 min-w-40 py-2 rounded text-white bg-coral-400 hover:bg-coral-300" @click="storeFeedbackRequest()">
              {{ __("Send") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import Layout from '@/Shared/Layout';
  import Icon from '@/Shared/Icon';
  import Pagination from '@/Shared/Pagination';
  import CheckboxField from '@/Shared/CheckboxField';
  import JobMenu from "../Jobs/JobMenu";

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__('Create new notification for #:id', {id: this.job.id}),
      }
    },
    props: {
      job: Object,
    },
    components: {
      Layout,
      Pagination,
      Icon,
      JobMenu,
      CheckboxField
    },
    data() {
      return {
        form: {
          media: []
        }
      }
    },
    mounted() {
      this.form.media = this.job.media;
    },
    methods: {
      storeFeedbackRequest() {
        if (confirm(this.__("Confirm"))) {
          this.$inertia.post(this.route('feedbackRequests.store', {job: this.job.id}), {
            media: this.form.media.filter((operation) => operation.checked).map((operation) => operation.id)
          });
        }
      }
    }
  }
</script>
